module.exports = __webpack_public_path__ + "img/practice-3.8ade51d2.jpg";